import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import type { ApiServerEntityIDType } from "../../../types";
import { ClientPhotoViewModel } from "../photo/view";
import { ClientAudioViewModel } from "../audio/view";
import { ClientPatronageStage } from "../../admin/clientPatronage/stage";
import { Sex } from "./sex";

export class ClientProfileCatalogViewModel {
  @Expose()
  @ApiProperty()
  id: ApiServerEntityIDType;

  @Expose()
  @ApiProperty({ required: false })
  name?: string;

  @Expose()
  @ApiProperty({ required: false })
  surname?: string;

  @Expose()
  @ApiProperty({ required: false })
  patronymic?: string;

  @Expose()
  @ApiProperty({ required: false })
  age?: number;

  @Expose()
  @ApiProperty({ required: false })
  mainPhoto?: ClientPhotoViewModel;

  @Expose()
  @ApiProperty({ required: false })
  photoSet?: ClientPhotoViewModel[];

  @Expose()
  @ApiProperty({ required: false })
  mainCareerId?: ApiServerEntityIDType;

  @Expose()
  @ApiProperty({ required: false })
  mainResumeId?: ApiServerEntityIDType;

  @Expose()
  @ApiProperty({ required: false })
  sex?: Sex;

  @Expose()
  @ApiProperty({ required: false })
  location?: string;

  @ApiProperty({ required: false, enum: ClientPatronageStage, enumName: 'ClientPatronageStage' })
  patronageStage?: ClientPatronageStage;

  @Expose()
  @ApiProperty()
  isDocumentsChecked: boolean;

  @Expose()
  @ApiProperty()
  createdAt: string;
  @Expose()
  @ApiProperty()
  lastActivityAt: string; // date ISO

  @Expose()
  @ApiProperty()
  isOnline: boolean;

  @ApiProperty({ required: false })
  trainingCompletedAt?: string; // date ISO

  @ApiProperty()
  cityAlias?: string;

  @Expose()
  @ApiProperty()
  hasAudio: boolean;

  @Expose()
  @ApiProperty({ type: [ClientAudioViewModel], required: false })
  audio?: ClientAudioViewModel[];
}
